import React, { useEffect, useState, useRef } from "react";
import MenuHeader from "./MenuHeader";
import Stack from "@mui/material/Stack";
import { styled } from "@mui/material/styles";
import Switch from "@mui/material/Switch";
import Modal from "react-modal";
import Typography from "@mui/material/Typography";
import imageFile from "../assets/images/upload-file.svg";
import useApi from "../hooks/useApi";
import Swal from "sweetalert2";
import ProductService from "../services/product.service";
import HotelService from "../services/hotel.service";
import DomainService from "../services/domain.service";
import CategoryService from "../services/category.service";
import ZoneService from "../services/zone.service";
import { asTitle } from "../shared/utils/string";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { Menu, MenuList, MenuItem, IconButton, ListItemText, ListItemIcon, Divider, TextField, Button, Tooltip } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useTranslatableData } from '../hooks/useTranslatable';
import MultilingualInput from './MultilingualInput';

const customStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    transform: "translate(-50%, -50%)",
    position: "absolute",
    boxshadow: "0 0 10px rgba(0, 0, 0, 0.5)",
    overflowX: "hidden",
    scrollbarWidth: "none",
    height: "680px",
  },
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: "flex",
  "&:active": {
    "& .MuiSwitch-thumb": {
      width: 15,
    },
    "& .MuiSwitch-switchBase.Mui-checked": {
      transform: "translateX(9px)",
    },
  },
  "& .MuiSwitch-switchBase": {
    padding: 2,
    "&.Mui-checked": {
      transform: "translateX(12px)",
      color: "#fff",
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#8fa9b9",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    boxShadow: "0 2px 4px 0 rgb(0 35 11 / 20%)",
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(["width"], {
      duration: 200,
    }),
  },
  "& .MuiSwitch-track": {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: "rgba(0,0,0,.25)",
    boxSizing: "border-box",
  },
}));

const Product = () => {
  const { t, i18n } = useTranslation('product');
  const currentLang = i18n.language?.startsWith('fr') ? 'fr' : 'en';
  Modal.setAppElement("#root");

  const [modalIsOpen, setIsOpen] = React.useState(false);
  const [products, setProducts] = useState([]);
  const [domain, setDomain] = useState([]);
  const [category, setCategory] = useState([]);
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [productList, setProductList] = useState([]);
  
  // Use translated data for display
  const translatedProducts = useTranslatableData(products, ['name', 'domain.title', 'category.title', 'category.parent.title', 'sub_products.name']);
  const translatedDomains = useTranslatableData(domain);
  const translatedCategories = useTranslatableData(categories);
  const translatedSubCategories = useTranslatableData(subCategories);
  const translatedProductList = useTranslatableData(productList);
  const api = useApi();
  const [currentPage, setCurrentPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [total, setTotal] = useState(0);
  const [lastPage, setLastPage] = useState(1);
  const [hoveredRow, setHoveredRow] = useState(null);
  const fileInputRef = useRef(null);
  const [fileName, setFileName] = useState("");
  const [file, setFile] = useState(null);
  const [hotelProd, setHotelProd] = useState(null);
  const [filterData, setFilterData] = useState({
    search: "",
    domain: "",
    category: "",
    duration: "",
    is_active: "",
    is_hidden: "",
  });

  const [productFilters, setProductFilters] = useState({});
  const [filtersProduct, setFiltersProducts] = useState({});
  const [domainFilters, setDomainFilters] = useState({});
  const [categoryFilters, setCategoryFilters] = useState({});

  const [formData, setFormData] = useState({
    id: "",
    category_id: "",
    domain_id: "",
    subcategory_id: "",
    product_id: "",
    parent_id: "",
    parent_category_id: "",
    name: "",
    title: "",
    duration: "",
    type: "product",
    is_active: true,
    is_hidden: false,
    price: "",
    description: "",
    subproduct: "",
    hotel_id: "",
  });

  // Translation states (default language: en)
  const [nameTranslations, setNameTranslations] = useState({ en: '', fr: '' });
  const [titleTranslations, setTitleTranslations] = useState({ en: '', fr: '' });
  const [descriptionTranslations, setDescriptionTranslations] = useState({ en: '', fr: '' });

  const parseToTranslations = (val) => {
    if (!val) return { en: '', fr: '' };
    if (typeof val === 'object' && (val.en !== undefined || val.fr !== undefined)) {
      return { en: val.en || '', fr: val.fr || '' };
    }  
    const result = { en: '', fr: '' };
    result[currentLang] = String(val);
    return result;
  };

  // Helper to build is_active filter in the form the backend's Filterable expects
  // Use operator syntax so '0' isn't treated as empty by PHP's empty() check.
  const buildIsActiveFilter = (v) => {
    if (v === '' || v === undefined || v === null) return '';
    // accept booleans or strings
    if (v === true || v === 'true' || v === '1' || v === 1) return 'eq:1';
    if (v === false || v === 'false' || v === '0' || v === 0) return 'eq:0';
    // fallback: if it's already operator syntax, pass through
    if (String(v).includes(':')) return String(v);
    return String(v);
  };

  // View type and dataset states (used separately from singular lists)
  const [viewType, setViewType] = useState('product');
  const [domainsData, setDomainsData] = useState([]);
  const [categoriesData, setCategoriesData] = useState([]);
  const [parentCategories, setParentCategories] = useState([]);
  const [subCategoriesData, setSubCategoriesData] = useState([]);

  // Translated versions for display
  const translatedDomainsData = useTranslatableData(domainsData, ['title']);
  const translatedCategoriesData = useTranslatableData(categoriesData, ['title', 'parent.title', 'domain.title']);
  const translatedSubCategoriesData = useTranslatableData(subCategoriesData, ['title', 'parent.title', 'domain.title']);
  
  const [sortField, setSortField] = useState(""); // Active sort field
  const [sortDirection, setSortDirection] = useState(true);
  const timeoutRef = useRef(null);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [availableZones, setAvailableZones] = useState([]);
  const [assignedZones, setAssignedZones] = useState([]);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [zoneModalIsOpen, setZoneModalIsOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [anchorElDomain, setAnchorElDomain] = useState(null);
  const [anchorElCategory, setAnchorElCategory] = useState(null);
  const [selectedDomainIndex, setSelectedDomainIndex] = useState(null);
  const [selectedCategoryIndex, setSelectedCategoryIndex] = useState(null);
  const [allZones, setAllZones] = useState([]);
  const [hotels, setHotels] = useState([]);
  const hotelsFetched = useRef(false);

  // Helper: domain object selected in the form. Check domainsData first, then fallback to `domain` state.
  const selectedDomainObj = (domainsData.find(d => String(d.id) === String(formData.domain_id)) || domain.find(d => String(d.id) === String(formData.domain_id)));

  const handleViewTypeChange = async (value) => {
    setViewType(value);
    setFilterData({
      search: "",
      domain: "",
      category: "",
      duration: "",
      is_active: "",
      is_domain_active: "",
      is_category_active: "",
    });
    await fetchData(value); // Fetch data with relevant filters
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;

    if (hotelProd) {
      setFormData({ ...formData, hotel_id: hotelProd })
    }

    // SUBCATEGORY creation
    if (formData.type === "subcategory" && name === "domain_id") {
      if (value) {
        try {
          const topLevelCategories = await CategoryService.index({ domain_id: value, parent_id: null, status: 'ACTIVE' }, api);
          setCategories(topLevelCategories);
        } catch (error) {

        }
      } else {
        setCategories([]);
      }
    }

    // PRODUCT or SUBPRODUCT creation
    if ((formData.type === "product" || formData.type === "subproduct") && name === "domain_id") {
      if (value) {
        try {
          const topLevelCategories = await CategoryService.index({ domain_id: value, parent_id: null, status: 'ACTIVE' }, api);
          setCategories(topLevelCategories);
        } catch (error) {

        }
      } else {
        setCategories([]);
      }
    }

    // CATEGORY creation
    if (formData.type === "category" && name === "domain_id") {
      if (!value) {
        // No domain selected, just reset domain_id
        setFormData({ ...formData, domain_id: "" });
      }
    }

    // SUBCATEGORY creation
    if (formData.type === "subcategory" && name === "parent_category_id") {
      if (value) {
        try {
          const response = await CategoryService.index(
            { parent_id: value, status: 'ACTIVE' },
            api
          );
          setSubCategories(response);
        } catch (error) {
          console.error(error);
        }
      } else {
        setSubCategories([]);
        setFormData({ ...formData, parent_category_id: "" });
      }
    }

    // PRODUCT or SUBPRODUCT creation
    if ((formData.type === "product" || formData.type === "subproduct") && name === "parent_category_id") {
      if (value) {
        try {
          const response = await CategoryService.index(
            { parent_id: value, status: 'ACTIVE' },
            api
          );
          setSubCategories(response);
        } catch (error) {
          console.error("Failed fetching subcategories for product:", error);
        }
      } else {
        setSubCategories([]);
        setFormData({ ...formData, parent_category_id: "" });
      }
    }

    // Handle file input
    if (name === "file") {
      console.log({ e });
      const file = e.target.files[0];
      if (file) {
        setFileName(file.name);
        setFile(file);
      }
    } else {
      setFormData({
        ...formData,
        [name]: value,
      });
    }

    if (name === "type") {
      resetForm(value)
    }
  };

  const resetForm = (type = 'product') => {
    setFormData({
      id: "",
      category_id: "",
      domain_id: "",
      subcategory_id: "",
      product_id: "",
      parent_id: "",
      parent_category_id: "",
      name: "",
      title: "",
      duration: "",
      type: type,
      is_active: true,
      is_hidden: false,
      price: "",
      description: "",
      subproduct: "",
      hotel_id: "",
    });

    // Reset the file input
    if (fileInputRef.current) {
      fileInputRef.current.value = '';
    }

    setFile(null);
    setFileName("");
    setCategories([]);
    setSubCategories([]);
    setProductList([]);
    setHotelProd(null);

    // Reset translation states
    setNameTranslations({ en: '', fr: '' });
    setTitleTranslations({ en: '', fr: '' });
    setDescriptionTranslations({ en: '', fr: '' });
  };

  const fetchData = async (type = viewType, filters = {}) => {
    try {
      const updatedFilters = {
        ...filters,
        page: currentPage,
        per_page: perPage,
      };

      if (type === "product") {
    const [response, domaineResponse, categoryResponse] = await Promise.all([
          ProductService.index({ with: "media,category.parent,domain,domain.hotel,parent,hotel", ...updatedFilters }, api),
          DomainService.index({ with: "hotel" }, api),
          CategoryService.index({ with: "parent" }, api),
        ]);
      setProducts(response.data);

      // Client-side fallback: if the caller requested an is_active filter (eq:1 / eq:0)
      // and the server returned unfiltered results, apply the filter locally so UI matches the selection.
      let productsData = response.data || [];
      try {
        const requestedIsActive = (updatedFilters && updatedFilters.is_active) ? String(updatedFilters.is_active) : '';
        if (requestedIsActive.startsWith('eq:')) {
          const val = requestedIsActive.split(':')[1];
          // val expected to be '1' or '0'
          const boolVal = (val === '1');
          productsData = productsData.filter(p => Boolean(p.is_active) === boolVal);
          // adjust totals locally
          const filteredTotal = productsData.length;
          setTotal(filteredTotal);
          setLastPage(1);
        } else {
          setTotal(response.total);
          setLastPage(response.last_page);
        }
      } catch (e) {
        // fallback to server totals if anything goes wrong
        setTotal(response.total);
        setLastPage(response.last_page);
      }

      setProducts(productsData);
        setDomain(domaineResponse);
        // categoryResponse may be paginated (with .data) or an array; normalize and populate both
        const catData = categoryResponse?.data ?? categoryResponse;
        setCategory(catData);
        setCategories(catData);
        setTotal(response.total);
        setLastPage(response.last_page);
        if (response.last_page < currentPage) {
          setProductFilters({ ...filters, page: response.last_page })
          setFiltersProducts({ ...filters, page: response.last_page })
          setCurrentPage(response.last_page);
        }
      } else if (type === "domain") {
        const domainResponse = await DomainService.index({ ...updatedFilters, with: "media,zones,hotel" }, api);
        // Client-side fallback filtering for domains when is_active operator provided
        let domainsList = domainResponse.data || [];
        try {
          const requestedIsActive = (updatedFilters && updatedFilters.is_active) ? String(updatedFilters.is_active) : '';
          if (requestedIsActive.startsWith('eq:')) {
            const val = requestedIsActive.split(':')[1];
            const boolVal = (val === '1');
            domainsList = domainsList.filter(d => Boolean(d.is_active) === boolVal);
            setTotal(domainsList.length);
            setLastPage(1);
          } else {
            setTotal(domainResponse.total);
            setLastPage(domainResponse.last_page);
          }
        } catch (e) {
          setTotal(domainResponse.total);
          setLastPage(domainResponse.last_page);
        }
        setDomainsData(domainsList);
        setDomain(domainsList);
        if (domainResponse.last_page < currentPage) {
          setDomainFilters({ ...filters, page: domainResponse.last_page })
          setCurrentPage(domainResponse.last_page);
        }
      } else if (type === "category") {
        const [categoriesResponse, domaineResponse] = await Promise.all([
          CategoryService.index({ with: "media,parent,domain,domain.hotel", ...updatedFilters, parent_id: null }, api),
          DomainService.index({ with: "hotel" }, api),
        ]);
        // Client-side fallback filtering for categories when is_active operator provided
        let categoriesList = categoriesResponse.data || [];
        try {
          const requestedIsActive = (updatedFilters && updatedFilters.is_active) ? String(updatedFilters.is_active) : '';
          if (requestedIsActive.startsWith('eq:')) {
            const val = requestedIsActive.split(':')[1];
            const boolVal = (val === '1');
            categoriesList = categoriesList.filter(c => Boolean(c.is_active) === boolVal);
            setTotal(categoriesList.length);
            setLastPage(1);
          } else {
            setTotal(categoriesResponse.total);
            setLastPage(categoriesResponse.last_page);
          }
        } catch (e) {
          setTotal(categoriesResponse.total);
          setLastPage(categoriesResponse.last_page);
        }
        setCategoriesData(categoriesList);
        setDomain(domaineResponse);
        console.log(categoriesResponse);
        // populate both lists used across the component
        setCategory(categoriesList);
        setCategories(categoriesList);
        if (categoriesResponse.last_page < currentPage) {
          setCategoryFilters({ ...filters, page: categoriesResponse.last_page })
          setCurrentPage(categoriesResponse.last_page);
        }
      }

      else if (type === "subcategory") {
        const [categoriesResponse, parentResponse] = await Promise.all([
          CategoryService.index({ with: "media,parent,domain,domain.hotel", ...updatedFilters, parent_id: '!eq:null' }, api),
          CategoryService.index({ parent_id: null }, api),
        ]);
        // Client-side fallback filtering for subcategories when is_active operator provided
        let subcategoriesList = categoriesResponse.data || [];
        try {
          const requestedIsActive = (updatedFilters && updatedFilters.is_active) ? String(updatedFilters.is_active) : '';
          if (requestedIsActive.startsWith('eq:')) {
            const val = requestedIsActive.split(':')[1];
            const boolVal = (val === '1');
            subcategoriesList = subcategoriesList.filter(c => Boolean(c.is_active) === boolVal);
            setTotal(subcategoriesList.length);
            setLastPage(1);
          } else {
            setTotal(categoriesResponse.total);
            setLastPage(categoriesResponse.last_page);
          }
        } catch (e) {
          setTotal(categoriesResponse.total);
          setLastPage(categoriesResponse.last_page);
        }
        setCategoriesData(subcategoriesList);
        setParentCategories(parentResponse);
        console.log(categoriesResponse.data);
        setCategory(subcategoriesList);
        setCategories(subcategoriesList);
        if (categoriesResponse.last_page < currentPage) {
          setCategoryFilters({ ...filters, page: categoriesResponse.last_page })
          setCurrentPage(categoriesResponse.last_page);
        }
      }
    } catch (error) {

    }
  };

  useEffect(() => {
    const fetchHotels = async () => {
      if (!hotelsFetched.current && hotels.length === 0) {
        try {
          hotelsFetched.current = true;
          const response = await HotelService.index({ with: 'address' }, api);
          setHotels(response.data || response);
        } catch (error) {
          console.error('Error fetching hotels:', error);
          hotelsFetched.current = false;
        }
      }
    };

    fetchHotels();
  }, [api]);

  useEffect(() => {
    fetchData(viewType, filtersProduct);
  }, [currentPage, perPage, viewType, filtersProduct]);

  const handleSwitchChange = (index, row) => async (event) => {
  await ProductService.update(row.id, { is_active: !row.is_active }, api);
  // Refetch using current product filters so the UI reflects the active filter immediately
  await fetchData("product", productFilters || filtersProduct);
  };

  const handleHiddenSwitchChange = (index, row) => async (event) => {
  await ProductService.update(row.id, { is_hidden: !row.is_hidden }, api);
  await fetchData("product", productFilters || filtersProduct);
  };

  const handleHiddenCatSwitchChange = (index, row) => async (event) => {
  await CategoryService.update(row.id, { is_hidden: !row.is_hidden }, api);
  // Use category filters when refetching
  await fetchData(viewType, categoryFilters);
  };

  const handleFormSwitchChange = (e) => {
    setFormData({ ...formData, is_active: !formData.is_active })
  }

  const handleHiddenFormSwitchChange = (e) => {
    setFormData({ ...formData, is_hidden: !formData.is_hidden })
  }

const handleSubmit = async (e) => {
  e.preventDefault();

  let newFormData = { ...formData };

  // Defensive: do not allow client to submit `ordering` on create requests.
  // Some UI flows may accidentally leave an ordering value in the form state; if
  // we're creating (no id) then remove it so the server can assign a safe value.
  if (!newFormData.id) {
    delete newFormData.ordering;
  }

  if ((newFormData.type === 'product' || newFormData.type === 'subproduct') && !newFormData.category_id) {
    newFormData.category_id = newFormData.parent_category_id;
  }

  if (newFormData.type === 'domain' && newFormData.zones) {
    delete newFormData.zones;
  }

  // Ensure translatable fields are sent as objects { en, fr }
  if (newFormData.type === 'domain') {
    newFormData.title = titleTranslations;
    newFormData.description = descriptionTranslations;
    if (!newFormData.id) delete newFormData.ordering;
  } else if (newFormData.type === 'category' || newFormData.type === 'subcategory') {
    newFormData.title = titleTranslations;
    newFormData.description = descriptionTranslations;
  } else if (newFormData.type === 'product' || newFormData.type === 'subproduct') {
    newFormData.name = nameTranslations;
    newFormData.description = descriptionTranslations;
  }

  // Fix empty field handling for all types
  Object.keys(newFormData).forEach(key => {
    if (newFormData[key] === '' || newFormData[key] === undefined) {
      // For integer fields that should be null instead of empty string
      if (['hotel_id', 'parent_id', 'category_id', 'domain_id', 'subcategory_id', 'product_id', 'parent_category_id'].includes(key)) {
        delete newFormData[key];
      }
    }
  });

  if (hotelProd) {
    newFormData.hotel_id = hotelProd;
  }

  console.log({ hotelProd });
  console.log({ newFormData });

  try {
    if (newFormData.id) {
      // For updates
      let dataToSend = newFormData;
      if (file) {
        const formDataToSend = new FormData();
        for (const key in newFormData) {
          const value = newFormData[key];
          if (value !== null && value !== undefined && value !== '') {
            if (typeof value === 'object') {
              formDataToSend.append(key, JSON.stringify(value));
            } else {
              formDataToSend.append(key, value);
            }
          }
        }
        formDataToSend.append("imageFile", file);
        dataToSend = formDataToSend;
      }

      switch (newFormData.type) {
        case 'product':
        case 'subproduct':
          await ProductService.updateWithImage(newFormData.id, dataToSend, api);
          break;
        case 'category':
        case 'subcategory':
          await CategoryService.updateWithImage(newFormData.id, dataToSend, api);
          break;
        default:
          await DomainService.updateWithImage(newFormData.id, dataToSend, api);
          break;
      }
      resetForm();
      closeModal();
      setTimeout(() => fetchData(viewType), 100);
    } else {
      // For creation - fix the API parameter issue
      switch (newFormData.type) {
        case 'product':
        case 'subproduct':
          if (file) {
            const formDataToSend = new FormData();
            for (const key in newFormData) {
              const value = newFormData[key];
              if (value !== null && value !== undefined && value !== '') {
                if (typeof value === 'object') {
                  formDataToSend.append(key, JSON.stringify(value));
                } else {
                  formDataToSend.append(key, value);
                }
              }
            }
            formDataToSend.append("imageFile", file);
            await ProductService.store(formDataToSend, api);
          } else {
            await ProductService.store(newFormData, api);
          }
          break;
        case 'category':
        case 'subcategory':
          if (file) {
            const formDataToSend = new FormData();
            for (const key in newFormData) {
              const value = newFormData[key];
              if (value !== null && value !== undefined && value !== '') {
                if (typeof value === 'object') {
                  formDataToSend.append(key, JSON.stringify(value));
                } else {
                  formDataToSend.append(key, value);
                }
              }
            }
            formDataToSend.append("imageFile", file);
            await CategoryService.store(formDataToSend, api);
          } else {
            await CategoryService.store(newFormData, api);
          }
          break;
        default:
          // For domains
          if (file) {
            const formDataToSend = new FormData();
            for (const key in newFormData) {
              const value = newFormData[key];
              if (value !== null && value !== undefined && value !== '') {
                if (typeof value === 'object') {
                  formDataToSend.append(key, JSON.stringify(value));
                } else {
                  formDataToSend.append(key, value);
                }
              }
            }
            formDataToSend.append("imageFile", file);
            await DomainService.store(formDataToSend, api);
          } else {
            await DomainService.store(newFormData, api);
          }
          break;
      }
      closeModal();
      fetchData(viewType);
    }
  } catch (error) {
    console.error(error);
  }
};
  async function openModal(data, type, editType) {
    resetForm();
    setFile(null);
    setFileName("");
    var nonTranslatedData = null;
    // Initialize translation states from existing data when editing
    switch(type) {
      case 'product':
        nonTranslatedData = products.find(element => element.id === data?.id) ?? data;
        break;
      case 'category':
        var id = editType === 'subcategory' ? data?.parent?.id : editType === 'category' ? data?.id : data?.category?.parent?.id ?? data?.category_id;
        if(editType === 'subcategory') {
          nonTranslatedData = parentCategories.find(element => element.id === id) ?? data;
        } else {
          nonTranslatedData = category.find(element => element.id === id) ?? data;
        }
        break;
      case 'subcategory':
        var id = editType === 'product' ? data?.category_id : data?.id;
        nonTranslatedData = category.find(element => element.id === id) ?? data;
        break
      case 'domain':
        nonTranslatedData = domain.find(element => element.id === data?.domain?.id) ?? data;
        break;
      default:
        nonTranslatedData = data;
        break;
    }

    const incomingTitle = nonTranslatedData?.title ?? nonTranslatedData?.domain?.title ?? nonTranslatedData?.category?.title ?? '';
    const incomingName = nonTranslatedData?.name ?? nonTranslatedData?.parent?.name ?? '';
    const incomingDescription = nonTranslatedData?.description ?? nonTranslatedData?.domain?.description ?? nonTranslatedData?.category?.description ?? '';
    setTitleTranslations(parseToTranslations(incomingTitle));
    setNameTranslations(parseToTranslations(incomingName));
    setDescriptionTranslations(parseToTranslations(incomingDescription));

    const domain_id = editType !== 'domain' ? data?.domain_id || "" : "";
    const category_id = editType === 'product' || editType === 'subproduct' ? data?.category?.parent_id || "" : editType === 'subcategory' ? data?.parent_id || "" : "";
    const subcategory_id = editType === 'product' || editType === 'subproduct' ? data?.category_id || "" : "";
    const product_id = editType === 'subproduct' ? data?.parent_id || "" : "";

    if (domain_id && domain_id != '') {
      try {
        const response = await CategoryService.index({ domain_id: domain_id, status: 'ACTIVE' }, api);
        setCategories(response);
      } catch (error) {

      }
    }

    if (category_id && category_id != '') {
      try {
        const response = await CategoryService.index({ parent_id: category_id, status: 'ACTIVE' }, api);
        setSubCategories(response);
      } catch (error) {

      }
    }

    if (subcategory_id && subcategory_id != '') {
      try {
        const response = await ProductService.index({ category_id: subcategory_id, status: 'ACTIVE' }, api);
        setProductList(response);
      } catch (error) {

      }
    }

    // Open the modal after resetting the form
    setIsOpen(true);
    switch (type) {
      case 'product': {
        let newParentId = "";
        let newSubcatId = "";

        if (data?.category?.parent_id) {
          newParentId = data.category.parent_id;
          newSubcatId = data.category_id;
        } else {
          newParentId = data.category_id;
          newSubcatId = "";
        }

        editType === 'product'
          ? setFormData({
            ...formData,
            ...data,
            type,
            parent_category_id: newParentId,
            category_id: newSubcatId
          })
          : setFormData({
            ...formData,
            ...data.parent,
            type,
            parent_category_id: newParentId
          });
        break;
      }
      case 'subproduct':
        setFormData({ ...formData, ...data, parent_category_id: category_id, parent_id: product_id, type });
        break;
      case 'domain':
        setFormData({ ...formData, ...data.domain, type, hotel_id: data.domain.hotel_id || "" });
        break;
      case 'subcategory':
        editType === 'product' || editType === 'subproduct' ? setFormData({ ...formData, ...data.category, type }) : setFormData({ ...formData, ...data, type });
        break;
      case 'category':
        if (editType === 'subcategory') {
          // parent category edit
          const payload = { ...formData, ...data.parent, type };
          // try to derive domain_id and hotel_id
          const domainId = payload.domain_id || data.parent?.domain_id || payload.domain_id;
          const domainObj = domainsData.find(d => String(d.id) === String(domainId));
          payload.domain_id = domainId || payload.domain_id;
          payload.hotel_id = domainObj?.hotel_id || payload.hotel_id || '';
          setFormData(payload);
        } else if (editType === 'category') {
          const payload = { ...formData, ...data, type };
          const domainId = payload.domain_id || data?.domain_id || payload.domain_id;
          const domainObj = domainsData.find(d => String(d.id) === String(domainId));
          payload.domain_id = domainId || payload.domain_id;
          payload.hotel_id = domainObj?.hotel_id || payload.hotel_id || '';
          setFormData(payload);
        } else {
          const src = (data.category?.parent ?? data.category) || {};
          const payload = { ...formData, ...src, type };
          const domainId = payload.domain_id || src?.domain_id || payload.domain_id;
          const domainObj = domainsData.find(d => String(d.id) === String(domainId));
          payload.domain_id = domainId || payload.domain_id;
          payload.hotel_id = domainObj?.hotel_id || payload.hotel_id || '';
          setFormData(payload);
        }
        break;
    }
  }

  function afterOpenModal() {
    // references are now sync'd and can be accessed.
    // subtitle.style.color = '#f00';
  }

  function closeModal() {
    resetForm();
    setIsOpen(false);
  }

  const handleDelete = async (id) => {
    if (viewType === "domain") {
      try {
        const response = await DomainService.delete(id, api);
        fetchData('domain');
      } catch (error) {

      }
    }
    else if (viewType === "category" || viewType ==="subcategory") {
      try {
        const response = await CategoryService.delete(id, api);
        fetchData(viewType);
      } catch (error) {

      }
    }
    else if (viewType === "product") {
      try {
        const response = await ProductService.delete(id, api);
        fetchData('product');
      } catch (error) {

      }
    }
  };

  const handleFilterSubmit = async (e) => {
    e.preventDefault();

    if (viewType === "domain") {
      const newDomainFilters = {
        title: filterData.search.trim(),
  is_active: buildIsActiveFilter(filterData.is_domain_active),
      };
      setDomainFilters(newDomainFilters);
      await fetchData("domain", newDomainFilters);
    } else if (viewType === "product") {
      const newProductFilters = {
        name: filterData.search.trim(),
  is_active: buildIsActiveFilter(filterData.is_active),
        domain_id: filterData.domain,
        category_id: filterData.category,
        duration: filterData.duration,
      };
      setProductFilters(newProductFilters);
      await fetchData("product", newProductFilters);
    } else if (viewType === "category") {
      const newCategoryFilters = {
        title: filterData.search.trim(),
  is_active: buildIsActiveFilter(filterData.is_category_active),
      };
      setCategoryFilters(newCategoryFilters);
      await fetchData("category", newCategoryFilters);
    }
  };

  const handleFilterChange = async (e) => {
    const { name, value } = e.target;
    setFilterData({
      ...filterData,
      [name]: value,
    });
    // If domain filter changed, update category list to reflect selected domain
    if (name === 'domain') {
      // clear selected category when domain changes
      setFilterData(prev => ({ ...prev, category: '' }));
      try {
        if (value) {
          const response = await CategoryService.index({ domain_id: value, with: 'parent' }, api);
          setCategories(response);
        } else {
          // no domain selected -> show all categories
          const response = await CategoryService.index({ with: 'parent' }, api);
          setCategories(response);
        }
      } catch (err) {
        console.error('Failed to fetch categories for domain filter:', err);
      }
    }
    if (name === "search" && value === "") {
      if (viewType === "domain") {
        await fetchData("domain", filterData);
      } else if (viewType === "product") {
        delete filterData.name;
        await fetchData("product", filterData);
      } else if (viewType === "category") {
        await fetchData("category", filterData);
      }
    }

    if (name === "is_active" || name === "is_domain_active" || name === "is_category_active") {
      if (viewType === "product") {
        const newProductFilters = {
          ...productFilters,
          is_active: buildIsActiveFilter(value),
          name: filterData.search.trim(),
          domain_id: filterData.domain,
          category_id: filterData.category,
          duration: filterData.duration,
        };
        setProductFilters(newProductFilters);
        await fetchData("product", newProductFilters);
      } else if (viewType === "domain") {
        const newDomainFilters = {
          ...domainFilters,
          is_active: buildIsActiveFilter(value),
          title: filterData.search.trim(),
        };
        setDomainFilters(newDomainFilters);
        await fetchData("domain", newDomainFilters);
      } else if (viewType === "category") {
        const newCategoryFilters = {
          ...categoryFilters,
          is_active: buildIsActiveFilter(value),
          title: filterData.search.trim(),
        };
        setCategoryFilters(newCategoryFilters);
        await fetchData("category", newCategoryFilters);
      }
    }
  };

  const handleNextPage = () => {
    if (currentPage < lastPage) setCurrentPage(currentPage + 1);
  };

  const handlePrevPage = () => {
    if (currentPage > 1) setCurrentPage(currentPage - 1);
  };

  const handleLastPage = () => {
    if (currentPage !== lastPage) setCurrentPage(lastPage);
  };

  const handleFirstPage = () => {
    if (currentPage !== 1) setCurrentPage(1);
  };

  const handlePerPageChange = (e) => {
    setPerPage(parseInt(e.target.value, 10));
    setCurrentPage(1);
  };

  const handleSelectedSort = async (event) => {
    const selected = document.querySelector('.sort-header.active');
    let direction = true;
    if (selected?.id !== event.target.id) {
      selected?.classList.remove('active');
      event.target.classList.add('active');
      setSortDirection(true);
    } else {
      setSortDirection(!sortDirection);
      direction = !sortDirection;
    }

    const sortField = event.target.id === 'name' ? `${direction ? '' : '-'}name` : `${direction ? '' : '-'}${event.target.id}`;


    // Apply sorting to the appropriate view
    const updatedFilters = { ...filtersProduct, sort: sortField, page: 1 };

    // Update the filters and fetch data for the selected view type
    switch (viewType) {
      case "product":
        setProductFilters(updatedFilters);
        await fetchData("product", updatedFilters);
        break;
      case "domain":
        setDomainFilters(updatedFilters);
        await fetchData("domain", updatedFilters);
        break;
      case "category":
        setCategoryFilters(updatedFilters);
        await fetchData("category", updatedFilters);
        break;
      default:
        break;
    }
  };

  const handleEditMouseEnter = (index) => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
    }
    setHoveredRow(index);
  };

  const handleEditMouseLeave = () => {
    timeoutRef.current = setTimeout(() => {
      setHoveredRow(null);
    }, 250);
  };

  const handleClick = (event, index) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    setSelectedIndex(index);
  };

  const handleClose = () => {
    setAnchorEl(null);
    setSelectedIndex(null);
  };

  // ---- Manage Zone ------

  const openZoneModal = async (domain) => {
    setSelectedDomain(domain);

    const assigned = domain.zones || [];
    setAssignedZones(assigned);

    try {
      const response = await ZoneService.index(null, api);
      setAllZones(response);

      const assignedIds = assigned.map(z => z.id);
      const unassigned = response.filter(z => !assignedIds.includes(z.id));

      setAvailableZones(unassigned);
    } catch (error) {

    }

    setZoneModalIsOpen(true);
  };

  const closeZoneModal = () => {
    setZoneModalIsOpen(false);
    setSelectedDomain(null);
    setAssignedZones([]);
    setAvailableZones([]);
  };

  const handleAssignZone = (zone) => {
    setAssignedZones(prev => [...prev, zone]);
    setAvailableZones(prev => prev.filter(z => z.id !== zone.id));
  };

  const handleUnassignZone = (zone) => {
    setAvailableZones((prev) => [...prev, zone]);
    setAssignedZones((prev) => prev.filter((z) => z.id !== zone.id));
  };

  const handleSaveZones = async () => {
    if (!selectedDomain) return;

    try {
      const zoneIds = assignedZones.map((z) => z.id);
      await DomainService.update(selectedDomain.id, { zones: zoneIds }, api);
      fetchData("domain");
      closeZoneModal();
    } catch (error) {

    }
  };

  // Handle search for zones
  const handleSearch = () => {
    const filteredZones = availableZones.filter((zone) =>
      zone.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
    setAvailableZones(filteredZones);
  };

  const handleDomainMenuClick = (event, index) => {
    event.stopPropagation();
    setAnchorElDomain(event.currentTarget);
    setSelectedDomainIndex(index);
  };

  const handleDomainMenuClose = () => {
    setAnchorElDomain(null);
    setSelectedDomainIndex(null);
  };

  const handleCategoryMenuClick = (event, index) => {
    event.stopPropagation();
    setAnchorElCategory(event.currentTarget);
    setSelectedCategoryIndex(index);
  };

  const handleCategoryMenuClose = () => {
    setAnchorElCategory(null);
    setSelectedCategoryIndex(null);
  };

  const [filterMenuAnchor, setFilterMenuAnchor] = useState(null);
  const filterMenuOpen = Boolean(filterMenuAnchor);

  const handleFilterMenuClick = (event) => {
    setFilterMenuAnchor(event.currentTarget);
  };

  const handleFilterMenuClose = () => {
    setFilterMenuAnchor(null);
  };

  return (
    <>
      <MenuHeader />
      <div className="product-breadcumb bloc-search bloc-search-mobile">
        <div className="container">
          <div className="desktop-hidden">
            <IconButton onClick={handleFilterMenuClick}>
              <img src='assets/images/filter.png' alt='actions' height={20} />
            </IconButton>
            <Menu anchorEl={filterMenuAnchor}
              open={filterMenuOpen}
              onClose={handleFilterMenuClose}
            >
              <MenuList
                style={{ padding: 0 }}
              >
                <MenuItem onClick={handleFilterMenuClose} disableRipple>
                  <ListItemIcon>
                    <img src='assets/images/filter.png' alt='actions' height={20} />

                  </ListItemIcon>
                  <ListItemText>Filters</ListItemText>
                </MenuItem>
                <Divider></Divider>
                <div className="bloc-filtre filtre-products">
                  <div className="search">
                    <select onChange={(e) => handleViewTypeChange(e.target.value)} value={viewType}>
                      <option value="domain">{t('filters.all.domains')}</option>
                      <option value="category">{t('filters.all.categories')}</option>
                      <option value="subcategory">{t('filters.all.subcategories')}</option>
                      <option value="product">{t('filters.all.products')}</option>
                    </select>
                  </div>
                  {viewType === "product" && (
                    <div className="bloc-search no-background">
                      <div className="container">
                        <form onSubmit={handleFilterSubmit} className="search search-mobile-product">
                          <div className="text-search">
                            <input
                              type="text"
                              name="search"
                              value={filterData.search}
                              onChange={handleFilterChange}
                              placeholder={t('filters.placeholder.searchByName')}
                              className="form-text"
                            />
                            <input type="submit" className="form-submit" value={t('actions.search')} />
                          </div>
                          <select onChange={handleFilterChange} name="domain" value={filterData.domain}>
                            <option value="">{t('filters.domain')}</option>
                            {translatedDomains.map((row) => (
                              <option key={row.id} value={row.id}>
                                {row.title}
                              </option>
                            ))}
                          </select>
                          <select onChange={handleFilterChange} name="category" value={filterData.category}>
                            <option value="">{t('filters.category')}</option>
                            {translatedCategories.map((row) => (
                              <option key={row.id} value={row.id}>
                                {row.title}
                              </option>
                            ))}
                          </select>
                          <select onChange={handleFilterChange} name="duration" value={filterData.duration}>
                            <option value="">{t('filters.duration.label')}</option>
                            <option value="30">30 {t('filters.duration.minutes')}</option>
                            <option value="60">60 {t('filters.duration.minutes')}</option>
                            <option value="90">90 {t('filters.duration.minutes')}</option>
                          </select>
                          <select onChange={handleFilterChange} name="is_active" value={filterData.is_active}>
                            <option value="">{t('filters.status.label')}</option>
                            <option value={true}>{t('filters.status.active')}</option>
                            <option value={false}>{t('filters.status.disabled')}</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  )}

                  {viewType === "domain" && (
                    <div className="bloc-search no-background">
                      <div className="container">
                        <form onSubmit={handleFilterSubmit} className="search">
                          <div className="text-search">
                            <input
                              type="text"
                              name="search"
                              value={filterData.search}
                              onChange={handleFilterChange}
                              placeholder={t('filters.placeholder.searchByTitle')}
                              className="form-text"
                            />
                            <input type="submit" className="form-submit" value={t('actions.search')} />
                          </div>
                          <select onChange={handleFilterChange} name="is_domain_active" value={filterData.is_domain_active}>
                            <option value="">{t('filters.status.label')}</option>
                            <option value={true}>{t('filters.status.active')}</option>
                            <option value={false}>{t('filters.status.disabled')}</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  )}

                  {(viewType === "category" || viewType === "subcategory") && (
                    <div className="bloc-search no-background">
                      <div className="container">
                        <form onSubmit={handleFilterSubmit} className="search">
                          <div className="text-search">
                            <input
                              type="text"
                              name="search"
                              value={filterData.search}
                              onChange={handleFilterChange}
                              placeholder={t('filters.placeholder.searchByTitle')}
                              className="form-text"
                            />
                            <input type="submit" className="form-submit" value={t('actions.search')} />
                          </div>
                          <select onChange={handleFilterChange} name="is_category_active" value={filterData.is_category_active}>
                            <option value="">{t('filters.status.label')}</option>
                            <option value={true}>{t('filters.status.active')}</option>
                            <option value={false}>{t('filters.status.disabled')}</option>
                          </select>
                        </form>
                      </div>
                    </div>
                  )}
                </div>
              </MenuList>
            </Menu>
          </div>
          <div className="mobile-hidden">
            <div className="bloc-filtre filtre-products">
              <div className="search search-parent">
                <select onChange={(e) => handleViewTypeChange(e.target.value)} value={viewType}>
                  <option value="domain">{t('filters.all.domains')}</option>
                  <option value="category">{t('filters.all.categories')}</option>
                  <option value="subcategory">{t('filters.all.subcategories')}</option>
                  <option value="product">{t('filters.all.products')}</option>
                </select>
              </div>

              {viewType === "product" && (
                <div className="bloc-search no-background">
                  <div className="container">
                    <form onSubmit={handleFilterSubmit} className="search">
                      <div className="text-search">
                        <input
                          type="text"
                          name="search"
                          value={filterData.search}
                          onChange={handleFilterChange}
                          placeholder={t('filters.placeholder.searchByName')}
                          className="form-text"
                        />
                        <input type="submit" className="form-submit" value={t('actions.search')} />
                      </div>
                      <select onChange={handleFilterChange} name="domain" value={filterData.domain}>
                        <option value="">{t('filters.domain')}</option>
                        {translatedDomains.map((row) => (
                          <option key={row.id} value={row.id}>
                            {row.title}
                          </option>
                        ))}
                      </select>
                      <select onChange={handleFilterChange} name="category" value={filterData.category}>
                        <option value="">{t('filters.category')}</option>
                        {translatedCategories.map((row) => (
                          <option key={row.id} value={row.id}>
                            {row.title}
                          </option>
                        ))}
                      </select>
                      <select onChange={handleFilterChange} name="duration" value={filterData.duration}>
                        <option value="">{t('filters.duration.label')}</option>
                        <option value="30">30 {t('filters.duration.minutes')}</option>
                        <option value="60">60 {t('filters.duration.minutes')}</option>
                        <option value="90">90 {t('filters.duration.minutes')}</option>
                      </select>
                      <select onChange={handleFilterChange} name="is_active" value={filterData.is_active}>
                        <option value="">{t('filters.status.label')}</option>
                        <option value={true}>{t('filters.status.active')}</option>
                        <option value={false}>{t('filters.status.disabled')}</option>
                      </select>
                    </form>
                  </div>
                </div>
              )}

              {viewType === "domain" && (
                <div className="bloc-search no-background">
                  <div className="container">
                    <form onSubmit={handleFilterSubmit} className="search">
                      <div className="text-search">
                        <input
                          type="text"
                          name="search"
                          value={filterData.search}
                          onChange={handleFilterChange}
                          placeholder={t('filters.placeholder.searchByTitle')}
                          className="form-text"
                        />
                        <input type="submit" className="form-submit" value={t('actions.search')} />
                      </div>
                      <select onChange={handleFilterChange} name="is_domain_active" value={filterData.is_domain_active}>
                        <option value="">{t('filters.status.label')}</option>
                        <option value={true}>{t('filters.status.active')}</option>
                        <option value={false}>{t('filters.status.disabled')}</option>
                      </select>
                    </form>
                  </div>
                </div>
              )}

              {(viewType === "category" || viewType === "subcategory") && (
                <div className="bloc-search no-background">
                  <div className="container">
                    <form onSubmit={handleFilterSubmit} className="search">
                      <div className="text-search">
                        <input
                          type="text"
                          name="search"
                          value={filterData.search}
                          onChange={handleFilterChange}
                          placeholder={t('filters.placeholder.searchByTitle')}
                          className="form-text"
                        />
                        <input type="submit" className="form-submit" value={t('actions.search')} />
                      </div>
                      <select onChange={handleFilterChange} name="is_category_active" value={filterData.is_category_active}>
                        <option value="">{t('filters.status.label')}</option>
                        <option value={true}>{t('filters.status.active')}</option>
                        <option value={false}>{t('filters.status.disabled')}</option>
                      </select>
                    </form>
                  </div>
                </div>
              )}
            </div>
          </div>

          <button onClick={() => openModal(null, null, null)} className="btn-add-product">
            {t('actions.add')}
          </button>
        </div>
      </div>

      <div className="tableau-list view-mobile view-rows">
        <div className="container">
          {viewType === "product" && (
            <div className="list-product">
              {translatedProducts.map((row, index) => (
                <div className="list-items" key={index}>
                  <div className="img-items">
                    <img
                      src={`${row.media[0]?.original_url}`}
                      alt="Product Logo"
                      style={{ width: "50px", height: "50px" }}
                    />
                  </div>
                  <div className="infos-items">
                    <div className="domain-txt-color">Domaine : {row?.domain?.title ? row?.domain?.title : '-'}</div>
                    <div>
                      Category : {row.category?.parent ? row.category.parent.title : row.category?.title || '-'}
                    </div>
                    <div>
                      Subcategory : {row.category?.parent ? row.category.title : '-'}
                    </div>
                    <div>Product : {row.name}</div>
                    {/* <div>
                      Subproduct : {row?.sub_products?.map((product, index) => `${product.name}${index === row.sub_products?.length - 1 ? '' : ', '}`)}
                    </div> */}
                    <div>Duration (min) : {row.duration}</div>
                    <div>Price (CHF) : {row.price}</div>
                    <div>
                      Is Hotel Product : {row.hotel_id ? "Yes" : "No"}
                    </div>
                    <div>
                      Hotel Name : {row?.hotel?.name ? row.hotel?.name ?? '-' : '-'}
                    </div>
                    <div className={row.is_active ? "active" : "disabled"}>
                      Status : <span>{row.is_active ? "Active" : "Disabled"}</span>
                    </div>
                    <div className="toggle-button-mobile">
                      Enable/Disable :
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        {/* Toggle Switch */}
                        <AntSwitch
                          checked={row.is_active}
                          onChange={handleSwitchChange(index, row)}
                          inputProps={{ "aria-label": "status-toggle" }}
                        />
                      </Stack>
                    </div>
                    <div className="toggle-button-mobile">
                      {t('table.enableDisable')} :
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        {/* Toggle Switch (hidden for items linked to a hotel) */}
                        <Tooltip title={row?.hotel ? t('tooltips.actionDisabledHotel') : ''}>
                          <span>
                            <AntSwitch
                              checked={row.is_hidden}
                              onChange={handleHiddenSwitchChange(index, row)}
                              inputProps={{ "aria-label": "status-toggle" }}
                              disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                            />
                          </span>
                        </Tooltip>
                      </Stack>
                    </div>
                  </div>
                  <div className="menu-edit">

                    {/* More Options Button */}
                    <IconButton onClick={(event) => handleClick(event, index)}>
                      <MoreVertIcon />
                    </IconButton>

                    {/* Material-UI Menu */}
                    <Menu
                      anchorEl={anchorEl}
                      open={Boolean(anchorEl) && selectedIndex === index} // Open only for selected row
                      onClose={handleClose}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuList style={{ minWidth: 200 }}>
                        {row.parent_id ? (
                          <>
                            <MenuItem onClick={() => { handleClose(); openModal(products[index], "domain", "subproduct"); }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>Edit Domain</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openModal(products[index], "product", "subproduct"); }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>Edit Parent Product</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openModal(products[index], "subcategory", "subproduct"); }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>Edit Category</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openModal(products[index], "category", "subproduct"); }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>Edit Parent Category</ListItemText>
                            </MenuItem>
                          </>
                        ) : (
                          <>
                            <MenuItem onClick={() => { handleClose(); openModal(products[index], "domain", "product"); }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>Edit Domain</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openModal(products[index], "product", "product"); }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>Edit Product</ListItemText>
                            </MenuItem>
                            <MenuItem onClick={() => { handleClose(); openModal(products[index], "category", "product"); }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>Edit Parent Category</ListItemText>
                            </MenuItem>
                          </>
                        )}

                        {/* Delete Option (products should still be deletable even if hotel-linked) */}
                        <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); handleDelete(row.id); }}>
                          <ListItemIcon><DeleteIcon style={{ color: "red" }} /></ListItemIcon>
                          <ListItemText>Delete</ListItemText>
                        </MenuItem>
                      </MenuList>
                    </Menu>
                  </div>
                </div>
              ))}
            </div>
          )}

          {viewType === "domain" && (
            <div className="list-product">
              {translatedDomainsData.map((row, index) => (
                <div key={index} className={!row.is_active ? "disabled-item list-items" : "list-items"}>
                  <div className="img-items">
                    <img
                      src={`${row.media[0]?.original_url}`}
                      alt="Domain Logo"
                      style={{ width: "50px", height: "50px", display: "inline" }}
                    />
                  </div>
                  <div className="infos-items">
                    <div className="domain-txt-color">
                      <input
                        type="number"
                        value={row.ordering}
                        onChange={(e) => {
                          const newOrdering = e.target.value;
                          const updatedDomains = [...domainsData];
                          const originalIndex = domainsData.findIndex(d => d.id === row.id);
                          updatedDomains[originalIndex].ordering = newOrdering;
                          setDomainsData(updatedDomains);
                        }}
                        onBlur={async (e) => {
                          const newOrdering = Number(e.target.value);
                          const isDuplicate = domainsData.some(
                            (domain) => domain.ordering === newOrdering && domain.id !== row.id
                          );

                          if (isDuplicate) {
                            toast.error("This ordering number is already assigned to another domain.");
                            fetchData("domain");
                            return;
                          }

                          try {
                            await DomainService.update(row.id, { ordering: newOrdering }, api);
                            fetchData("domain");
                          } catch (error) {
                            console.error("Failed to update ordering:", error);
                          }
                        }}
                        onKeyDown={async (e) => {
                          if (e.key === "Enter") {
                            e.target.blur();
                          }
                        }}
                        style={{ width: "60px", border: 0, background: "none" }}
                      />
                    </div>
                    <div className="domain-txt-color">Titre : {row.title}</div>
                    <div className="">Description : {row.description}</div>
                    <div className={row.is_active ? "active" : "disabled"}>
                      <span>{row.is_active ? "Active" : "Disabled"}</span>
                    </div>
                    <div className="toggle-button-mobile">
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        <AntSwitch
                          defaultChecked={row.is_active}
                          onChange={async () => {
                            await DomainService.update(row.id, { is_active: !row.is_active }, api);
                            await fetchData("domain", domainFilters);
                          }}
                          inputProps={{ "aria-label": "ant design" }}
                        />
                      </Stack>
                    </div>
                  </div>
                  <div className="menu-edit">
                    <IconButton onClick={(event) => handleDomainMenuClick(event, index)}>
                      <MoreVertIcon />
                    </IconButton>

                    <Menu
                      anchorEl={anchorElDomain}
                      open={Boolean(anchorElDomain) && selectedDomainIndex === index}
                      onClose={handleDomainMenuClose}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuList style={{ minWidth: 180 }}>
                        <MenuItem onClick={() => {
                          handleDomainMenuClose();
                          openModal({ domain: domainsData[index] }, "domain", "domain");
                        }}>
                          <ListItemIcon>
                            <EditIcon style={{ color: "#1976d2" }} />
                          </ListItemIcon>
                          <ListItemText>{t('menu.editDomain')}</ListItemText>
                        </MenuItem>

                        {/* Disable manage zones when domain is linked to a hotel */}
                        <Tooltip title={row?.hotel ? t('tooltips.zonesInherited') : ''}>
                          <span>
                            <MenuItem
                              onClick={() => {
                                handleDomainMenuClose();
                                openZoneModal(row);
                              }}
                              disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                            >
                              <ListItemIcon>
                                <EditIcon style={{ color: "#1976d2" }} />
                              </ListItemIcon>
                              <ListItemText>{t('menu.manageZones')}</ListItemText>
                            </MenuItem>
                          </span>
                        </Tooltip>

                        {/* Disable Delete for domains linked to a hotel */}
                        <Tooltip title={row?.hotel ? t('tooltips.actionDisabledHotel') : ''}>
                          <span>
                            <MenuItem
                              style={{ color: "red" }}
                              onClick={() => {
                                handleDomainMenuClose();
                                handleDelete(row.id);
                              }}
                              disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                            >
                              <ListItemIcon>
                                <DeleteIcon style={{ color: "red" }} />
                              </ListItemIcon>
                              <ListItemText>{t('menu.delete')}</ListItemText>
                            </MenuItem>
                          </span>
                        </Tooltip>
                      </MenuList>
                    </Menu>
                  </div>
                </div>
              ))}
            </div>
          )}

          {(viewType === "category" || viewType === "subcategory") && (
            <div className="list-product">
              {translatedCategoriesData.map((row, index) => (
                <div key={index} className={!row.is_active ? "disabled-item list-items" : "list-items"}>
                  <div className="img-items">
                    <img
                      src={`${row.media[0]?.original_url}`}
                      alt="Category Logo"
                      style={{ width: "50px", height: "50px", display: "inline" }}
                    />
                  </div>
                  <div className="infos-items">
                    <div>Titre : {row.title}</div>
                    <div>
                      Domaine : {row?.domain ? row?.domain?.title : '-'}
                    </div>
                    <div>{row.parent ? row.parent.title : "No parent"}</div>
                    <div className={row.is_active ? "active" : "disabled"}>
                      Statut : <span>{row.is_active ? "Active" : "Disabled"}</span>
                    </div>
                    <div className="toggle-button-mobile">
                      Enable/Disable :
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        <AntSwitch
                          defaultChecked={row.is_active}
                          onChange={async () => {
                            await CategoryService.update(row.id, { is_active: !row.is_active }, api);
                            if (viewType === "subcategory") {
                              await fetchData("subcategory", categoryFilters);
                            } else {
                              await fetchData("category", categoryFilters);
                            }
                          }}
                          inputProps={{ "aria-label": "ant design" }}
                        />
                      </Stack>
                    </div>
                    <div className="toggle-button-mobile">
                      {t('table.enableDisable')} :
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        {/* Toggle Switch (disabled for items linked to a hotel) */}
                        <Tooltip title={row?.hotel ? t('tooltips.actionDisabledHotel') : ''}>
                          <span>
                            <AntSwitch
                              checked={row.is_hidden}
                              onChange={handleHiddenCatSwitchChange(index, row)}
                              inputProps={{ "aria-label": "status-toggle" }}
                              disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                            />
                          </span>
                        </Tooltip>
                      </Stack>
                    </div>
                  </div>
                  <div className="menu-edit">
                    <IconButton onClick={(event) => handleCategoryMenuClick(event, index)}>
                      <MoreVertIcon />
                    </IconButton>

                    <Menu
                      anchorEl={anchorElCategory}
                      open={Boolean(anchorElCategory) && selectedCategoryIndex === index}
                      onClose={handleCategoryMenuClose}
                      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                      transformOrigin={{ vertical: "top", horizontal: "right" }}
                    >
                      <MenuList style={{ minWidth: 180 }}>
                        {row.parent ? (
                          <>
                            <MenuItem onClick={() => {
                              handleCategoryMenuClose();
                              openModal(categoriesData[index], "category", "subcategory");
                            }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>{t('menu.editParentCategory')}</ListItemText>
                            </MenuItem>

                            <MenuItem onClick={() => {
                              handleCategoryMenuClose();
                              openModal(categoriesData[index], "subcategory", "subcategory");
                            }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>{t('menu.editCategory')}</ListItemText>
                            </MenuItem>

                            <MenuItem onClick={() => {
                              handleCategoryMenuClose();
                              openModal(categoriesData[index], "domain", "subcategory");
                            }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>{t('menu.editDomain')}</ListItemText>
                            </MenuItem>
                          </>
                        ) : (
                          <>
                            <MenuItem onClick={() => {
                              handleCategoryMenuClose();
                              openModal(categoriesData[index], "category", "category");
                            }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>{t('menu.editCategory')}</ListItemText>
                            </MenuItem>

                            <MenuItem onClick={() => {
                              handleCategoryMenuClose();
                              openModal(categoriesData[index], "domain", "category");
                            }}>
                              <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                              <ListItemText>{t('menu.editDomain')}</ListItemText>
                            </MenuItem>
                          </>
                        )}

                        <Tooltip title={row?.domain?.hotel || row?.hotel ? t('tooltips.actionDisabledHotel') : ''}>
                          <span>
                            <MenuItem
                              style={{ color: "red" }}
                              onClick={() => {
                                handleCategoryMenuClose();
                                handleDelete(row.id);
                              }}
                              disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                            >
                              <ListItemIcon><DeleteIcon style={{ color: "red" }} /></ListItemIcon>
                              <ListItemText>{t('menu.delete')}</ListItemText>
                            </MenuItem>
                          </span>
                        </Tooltip>
                      </MenuList>
                    </Menu>

                  </div>
                </div>
              ))}
            </div>
          )}

        </div>
      </div>

      <div className="tableau-list view-desktop">
        <div className="container">
          {viewType === "product" && (
            <div className="sticky-table-container">
            <table className="sticky-table">
              <thead className="no-background">
                <tr>
                  <th id="domain_id" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.domain')}</th>
                  <th>{t('table.image')}</th>
                  <th id="category_id" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.category')}</th>
                  <th id="subcategory_id" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.subcategory')}</th>
                  <th id="name" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.product')}</th>
                  {/* <th id="subproduct" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.subproduct')}</th> */}
                  <th id="duration" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.duration')}</th>
                  <th id="price" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.price')}</th>
                  <th id="is_hotel_product" className="text-align-center">{t('table.isHotelProduct')}</th>
                  <th id="hotel_name" className="text-align-center">{t('table.hotelName')}</th>
                  <th id="is_active" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.active')}</th>
                  <th className="text-align-center">{t('table.enableDisable')}</th>
                  <th className="text-align-center">{t('table.hideUnhide')}</th>
                  <th className="text-align-center">{t('table.actions')}</th>
                </tr>
              </thead>
              <tbody>
                {translatedProducts.map((row, index) => (
                  <tr
                    key={index}
                    className={
                      !row?.is_active
                        ? "disabled-item"
                        : ""
                    }
                  >
                    <td className="domain-txt-color text-align-center">{row?.domain?.title ? row?.domain?.title : '-'}</td>
                    <td>
                      <img
                        src={`${row.media[0]?.original_url}`}
                        alt="Product Logo"
                        style={{ width: "50px", height: "50px" }}
                      />
                    </td>
                    <td className="text-align-center">
                      {row.category?.parent ? row.category.parent.title : row.category?.title || '-'}
                    </td>
                    <td className="text-align-center">
                      {row.category?.parent ? row.category.title : '-'}
                    </td>
                    <td className="text-align-center">{row.name}</td>
                    {/* <td className="text-align-center">
                      {row?.sub_products?.map((product, index) => `${product.name}${index === row.sub_products?.length - 1 ? '' : ', '}`)}
                    </td> */}
                    <td className="text-align-center">{row.duration}</td>
                    <td className="text-align-center">{row.price}</td>
                    <td className="text-align-center">
                      {row.hotel_id ? "Yes" : "No"}
                    </td>
                    <td className="text-align-center">
                      {row?.hotel?.name ? row.hotel?.name ?? '-' : '-'}
                    </td>
                    <td className={row.is_active ? "active text-align-center" : "disabled text-align-center"}>
                      {row.is_active ? "Active" : "Disabled"}
                    </td>
                    <td>
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        {/* Toggle Switch */}
                        <AntSwitch
                          checked={row.is_active}
                          onChange={handleSwitchChange(index, row)}
                          inputProps={{ "aria-label": "status-toggle" }}
                        />
                      </Stack>
                    </td>
                    <td>
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        {/* Toggle Switch (disabled for items linked to a hotel) */}
                        <Tooltip title={row?.hotel ? t('tooltips.actionDisabledHotel') : ''}>
                          <span>
                            <AntSwitch
                              checked={row.is_hidden}
                              onChange={handleHiddenSwitchChange(index, row)}
                              inputProps={{ "aria-label": "status-toggle" }}
                              disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                            />
                          </span>
                        </Tooltip>
                      </Stack>
                    </td>
                    <td className="text-align-center">

                      {/* More Options Button */}
                      <IconButton onClick={(event) => handleClick(event, index)}>
                        <MoreVertIcon />
                      </IconButton>

                      {/* Material-UI Menu */}
                      <Menu
                        anchorEl={anchorEl}
                        open={Boolean(anchorEl) && selectedIndex === index} // Open only for selected row
                        onClose={handleClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <MenuList style={{ minWidth: 200 }}>
                          {row?.category?.parent != null ? (
                            <>
                              <MenuItem onClick={() => { handleClose(); openModal(products[index], "domain", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editDomain')}</ListItemText>
                              </MenuItem>
                              <MenuItem onClick={() => { handleClose(); openModal(products[index], "product", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editProduct')}</ListItemText>
                              </MenuItem>
                              <MenuItem onClick={() => { handleClose(); openModal(products[index], "subcategory", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editCategory')}</ListItemText>
                              </MenuItem>
                              <MenuItem onClick={() => { handleClose(); openModal(products[index], "category", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editParentCategory')}</ListItemText>
                              </MenuItem>
                            </>
                          ) : (
                            <>
                              <MenuItem onClick={() => { handleClose(); openModal(products[index], "domain", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editDomain')}</ListItemText>
                              </MenuItem>
                              <MenuItem onClick={() => { handleClose(); openModal(products[index], "product", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editProduct')}</ListItemText>
                              </MenuItem>
                              {/* <MenuItem onClick={() => { handleClose(); openModal(products[index], "subcategory", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editCategory')}</ListItemText>
                              </MenuItem> */}
                              <MenuItem onClick={() => { handleClose(); openModal(products[index], "category", "product"); }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editParentCategory')}</ListItemText>
                              </MenuItem>
                            </>
                          )}

                          {/* Delete Option (products should remain deletable) */}
                          <MenuItem style={{ color: 'red' }} onClick={() => { handleClose(); handleDelete(row.id); }}>
                            <ListItemIcon><DeleteIcon style={{ color: "red" }} /></ListItemIcon>
                            <ListItemText>{t('menu.delete')}</ListItemText>
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot >
                <tr>
                  <td colSpan={14}>
                    <div className="paginator">
                      <select value={perPage} onChange={handlePerPageChange} className="per-page">
                        <option value={1}>1</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={250}>250</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>
                      <div className="total">{t('pagination.totalRecords')} {total}</div>
                      <div className="pagination">
                        <button type="button" disabled={currentPage === 1} onClick={handleFirstPage}>{'<<'}</button>
                        <button type="button" disabled={currentPage === 1} onClick={handlePrevPage}>{'<'}</button>
                        <span>{currentPage} / {lastPage}</span>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleNextPage}>{'>'}</button>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleLastPage}>{'>>'}</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
            </div>
          )}

          {viewType === "domain" && (
            <div className="sticky-table-container">
            <table className="sticky-table" style={{ width: '100%', textAlign: 'center' }}>
              <thead className="no-background">
                <tr>
                  <th id="ordering" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.ordering')}</th>
                  <th id="title" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.title')}</th>
                  <th id="description" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.description')}</th>
                  <th className="text-align-center">{t('table.hotel')}</th>
                  <th className="text-align-center">{t('table.image')}</th>
                  <th id="is_active" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.active')}</th>
                  <th className="text-align-center">{t('table.enableDisable')}</th>
                  <th className="text-align-center">{t('table.actions')}</th>
                </tr>
              </thead>
              <tbody>
                {translatedDomainsData.map((row, index) => (
                  <tr key={index} className={!row.is_active ? "disabled-item" : ""}>
                    <td className="domain-txt-color text-align-center">
                      <input
                        type="number"
                        value={row.ordering}
                        onChange={(e) => {
                          const newOrdering = e.target.value;
                          const updatedDomains = [...domainsData];
                          const originalIndex = domainsData.findIndex(d => d.id === row.id);
                          updatedDomains[originalIndex].ordering = newOrdering;
                          setDomainsData(updatedDomains);
                        }}
                        onBlur={async (e) => {
                          const newOrdering = Number(e.target.value);
                          const isDuplicate = domainsData.some(
                            (domain) => domain.ordering === newOrdering && domain.id !== row.id
                          );

                          if (isDuplicate) {
                            toast.error("This ordering number is already assigned to another domain.");
                            fetchData("domain");
                            return;
                          }

                          try {
                            await DomainService.update(row.id, { ordering: newOrdering }, api);
                            fetchData("domain");
                          } catch (error) {
                            console.error("Failed to update ordering:", error);
                          }
                        }}
                        onKeyDown={async (e) => {
                          if (e.key === "Enter") {
                            e.target.blur();
                          }
                        }}
                        style={{ width: "60px", textAlign: "center", border: 0, background: "none" }}
                      />
                    </td>
                    <td className="domain-txt-color text-align-center">{row.title}</td>
                    <td className="text-align-center">{row.description}</td>
                    <td className="text-align-center">{row.hotel_id ? row.hotel?.name ?? '-' : "N/A"}</td>
                    <td className="text-align-center">
                      <img
                        src={`${row.media[0]?.original_url}`}
                        alt="Domain Logo"
                        style={{ width: "50px", height: "50px", display: "inline" }}
                      />
                    </td>
                    <td className={row.is_active ? "active text-align-center" : "disabled text-align-center"}>
                      {row.is_active ? "Active" : "Disabled"}
                    </td>
                    <td className="text-align-center">
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        <AntSwitch
                          defaultChecked={row.is_active}
                          onChange={async () => {
                            await DomainService.update(row.id, { is_active: !row.is_active }, api);
                            await fetchData("domain", domainFilters);
                          }}
                          inputProps={{ "aria-label": "ant design" }}
                        />
                      </Stack>
                    </td>
                    <td className="text-align-center">
                      <IconButton onClick={(event) => handleDomainMenuClick(event, index)}>
                        <MoreVertIcon />
                      </IconButton>

                      <Menu
                        anchorEl={anchorElDomain}
                        open={Boolean(anchorElDomain) && selectedDomainIndex === index}
                        onClose={handleDomainMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <MenuList style={{ minWidth: 180 }}>
                          <MenuItem onClick={() => {
                            handleDomainMenuClose();
                            openModal({ domain: domainsData[index] }, "domain", "domain");
                          }}>
                            <ListItemIcon>
                              <EditIcon style={{ color: "#1976d2" }} />
                            </ListItemIcon>
                            <ListItemText>{t('menu.editDomain')}</ListItemText>
                          </MenuItem>

                          {/* Disable manage zones when domain is linked to a hotel */}
                          <Tooltip title={row?.hotel ? t('tooltips.zonesInherited') : ''}>
                            <span>
                              <MenuItem
                                onClick={() => {
                                  handleDomainMenuClose();
                                  openZoneModal(row);
                                }}
                                disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                              >
                                <ListItemIcon>
                                  <EditIcon style={{ color: "#1976d2" }} />
                                </ListItemIcon>
                                <ListItemText>{t('menu.manageZones')}</ListItemText>
                              </MenuItem>
                            </span>
                          </Tooltip>

                          <MenuItem
                            style={{ color: "red" }}
                            onClick={() => {
                              handleDomainMenuClose();
                              handleDelete(row.id);
                            }}
                          >
                            <ListItemIcon>
                              <DeleteIcon style={{ color: "red" }} />
                            </ListItemIcon>
                            <ListItemText>{t('menu.delete')}</ListItemText>
                          </MenuItem>
                        </MenuList>
                      </Menu>
                    </td>
                  </tr>
                ))}
              </tbody>
              <tfoot >
                <tr>
                  <td colSpan={7}>
                    <div className="paginator">
                      <select value={perPage} onChange={handlePerPageChange} className="per-page">
                        <option value={1}>1</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={250}>250</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>
                      <div className="total">{t('pagination.totalRecords')} {total}</div>
                      <div className="pagination">
                        <button type="button" disabled={currentPage === 1} onClick={handleFirstPage}>{'<<'}</button>
                        <button type="button" disabled={currentPage === 1} onClick={handlePrevPage}>{'<'}</button>
                        <span>{currentPage} / {lastPage}</span>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleNextPage}>{'>'}</button>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleLastPage}>{'>>'}</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
            </div>
          )}

          {(viewType === "category" || viewType === "subcategory") && (
            <div className="sticky-table-container">
            <table className="sticky-table">
              <thead className="no-background">
                <tr>
                  <th id="title" onClick={handleSelectedSort} className="sort-header text-align-center">{viewType === "category" ? t('table.title') : t('table.subcategory')}</th>
                  <th className="text-align-center">{t('table.image')}</th>
                  <th id="domain_id" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.domain')}</th>
                  <th className="text-align-center">{t('table.hotel')}</th>
                  <th id="parent.title" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.parent')}</th>
                  <th id="is_active" onClick={handleSelectedSort} className="sort-header text-align-center">{t('table.active')}</th>
                  <th className="text-align-center">{t('table.enableDisable')}</th>
                  <th className="text-align-center">{t('table.hideUnhide')}</th>
                  <th className="text-align-center">{t('table.actions')}</th>
                </tr>
              </thead>
              <tbody>
                {translatedCategoriesData.map((row, index) => (
                  <tr key={index} className={!row.is_active ? "disabled-item" : ""}>
                    <td className="text-align-center">{row.title}</td>
                    <td className="text-align-center">
                      <img
                        src={`${row.media[0]?.original_url}`}
                        alt="Category Logo"
                        style={{ width: "50px", height: "50px", display: "inline" }}
                      />
                    </td>
                    <td className="text-align-center">
                      {row?.domain ? row?.domain?.title : '-'}
                    </td>
                    <td className="text-align-center">
                      {row?.domain?.hotel ? row?.domain?.hotel?.name : '-'}
                    </td>
                    <td className="text-align-center">{row.parent ? row.parent.title : "No parent"}</td>
                    <td className={row.is_active ? "active text-align-center" : "disabled text-align-center"}>
                      {row.is_active ? "Active" : "Disabled"}
                    </td>
                    <td>
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        <AntSwitch
                          defaultChecked={row.is_active}
                          onChange={async () => {
                            await CategoryService.update(row.id, { is_active: !row.is_active }, api);
                            if (viewType === "subcategory") {
                              await fetchData("subcategory", categoryFilters);
                            } else {
                              await fetchData("category", categoryFilters);
                            }
                          }}
                          inputProps={{ "aria-label": "ant design" }}
                        />
                      </Stack>
                    </td>
                    <td>
                      <Stack
                        direction="row"
                        spacing={0}
                        sx={{ alignItems: 'center', justifyContent: 'center' }}
                      >
                        {/* Toggle Switch (disabled for items linked to a hotel) */}
                        <Tooltip title={row?.hotel ? t('tooltips.actionDisabledHotel') : ''}>
                          <span>
                            <AntSwitch
                              checked={row.is_hidden}
                              onChange={handleHiddenCatSwitchChange(index, row)}
                              inputProps={{ "aria-label": "status-toggle" }}
                              disabled={Boolean(row?.hotel || row?.domain?.hotel || row?.domain?.hotel_id)}
                            />
                          </span>
                        </Tooltip>
                      </Stack>
                    </td>
                    <td className="text-align-center">
                      <IconButton onClick={(event) => handleCategoryMenuClick(event, index)}>
                        <MoreVertIcon />
                      </IconButton>

                      <Menu
                        anchorEl={anchorElCategory}
                        open={Boolean(anchorElCategory) && selectedCategoryIndex === index}
                        onClose={handleCategoryMenuClose}
                        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                        transformOrigin={{ vertical: "top", horizontal: "right" }}
                      >
                        <MenuList style={{ minWidth: 180 }}>
                          {row.parent ? (
                            <>
                              <MenuItem onClick={() => {
                                handleCategoryMenuClose();
                                openModal(categoriesData[index], "category", "subcategory");
                              }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editParentCategory')}</ListItemText>
                              </MenuItem>

                              <MenuItem onClick={() => {
                                handleCategoryMenuClose();
                                openModal(categoriesData[index], "subcategory", "subcategory");
                              }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editCategory')}</ListItemText>
                              </MenuItem>

                              <MenuItem onClick={() => {
                                handleCategoryMenuClose();
                                openModal(categoriesData[index], "domain", "subcategory");
                              }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editDomain')}</ListItemText>
                              </MenuItem>
                            </>
                          ) : (
                            <>
                              <MenuItem onClick={() => {
                                handleCategoryMenuClose();
                                openModal(categoriesData[index], "category", "category");
                              }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editCategory')}</ListItemText>
                              </MenuItem>

                              <MenuItem onClick={() => {
                                handleCategoryMenuClose();
                                openModal(categoriesData[index], "domain", "category");
                              }}>
                                <ListItemIcon><EditIcon style={{ color: "#1976d2" }} /></ListItemIcon>
                                <ListItemText>{t('menu.editDomain')}</ListItemText>
                              </MenuItem>
                            </>
                          )}

                          <MenuItem
                            style={{ color: "red" }}
                            onClick={() => {
                              handleCategoryMenuClose();
                              handleDelete(row.id);
                            }}
                          >
                            <ListItemIcon><DeleteIcon style={{ color: "red" }} /></ListItemIcon>
                            <ListItemText>{t('menu.delete')}</ListItemText>
                          </MenuItem>
                        </MenuList>
                      </Menu>

                    </td>
                  </tr>
                ))}
              </tbody>

              <tfoot >
                <tr>
                  <td colSpan={8}>
                    <div className="paginator">
                      <select value={perPage} onChange={handlePerPageChange} className="per-page">
                        <option value={1}>1</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                        <option value={250}>250</option>
                        <option value={500}>500</option>
                        <option value={1000}>1000</option>
                      </select>
                      <div className="total">{t('pagination.totalRecords')} {total}</div>
                      <div className="pagination">
                        <button type="button" disabled={currentPage === 1} onClick={handleFirstPage}>{'<<'}</button>
                        <button type="button" disabled={currentPage === 1} onClick={handlePrevPage}>{'<'}</button>
                        <span>{currentPage} / {lastPage}</span>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleNextPage}>{'>'}</button>
                        <button type="button" disabled={currentPage === lastPage} onClick={handleLastPage}>{'>>'}</button>
                      </div>
                    </div>
                  </td>
                </tr>
              </tfoot>
            </table>
            </div>
          )}
        </div>
      </div>

      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={customStyles}
        contentLabel={formData.id ? t(`modals.edit.${formData.type}`) : t(`modals.create.${formData.type}`)}
      >
        <button className="close-button" onClick={closeModal}>
          <span className="close-icon">✖</span>
        </button>

        <h2>{formData.id ? t(`modals.edit.${formData.type}`) : t(`modals.create.${formData.type}`)}</h2>
        <p>{t('messages.moreInfo')}</p>
        <div className="form-inscription">
          <form onSubmit={handleSubmit}>
            {(!formData.id) && (
              <div className="form-text">
                <select value={formData.type} name="type" onChange={handleChange}>
                  <option value="">{t('form.select.placeholder')}</option>
                  <option value="domain">{t('form.select.domain')}</option>
                  <option value="category">{t('form.select.category')}</option>
                  <option value="subcategory">{t('form.select.subcategory')}</option>
                  <option value="product">{t('form.select.product')}</option>
                </select>
              </div>
            )}

            {/* ---------- DOMAIN CREATION ---------- */}
            {formData.type === "domain" && (
              <>
                <div className="form-text">
                  <label>{t('form.title')} *</label>
                  <MultilingualInput value={titleTranslations} onChange={setTitleTranslations} defaultLang="fr" otherLang="en" />
                </div>
                <div className="form-text topMargArea">
                  <label>{t('form.associated_hotel')}</label>
                  <select
                    name="hotel_id"
                    value={formData.hotel_id}
                    onChange={handleChange}
                    className="form-select"
                  >
                    <option value="">{t('form.select_hotel')}</option>
                    {hotels.map(hotel => (
                      <option key={hotel.id} value={hotel.id}>
                        {hotel.name}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="form-text topMargArea">
                  <label>{t('form.description')}</label>
                  <MultilingualInput value={descriptionTranslations} onChange={setDescriptionTranslations} defaultLang="fr" otherLang="en" type="textarea" textareaClass="formTextArea" />
                </div>
              </>
            )}

            {/* ---------- CATEGORY CREATION ---------- */}
            {formData.type === "category" && (
              <>
                <div className="form-text">
                  <label>{t('form.domain')} *</label>
                  <select
                    required
                    name="domain_id"
                    onChange={handleChange}
                    value={formData.domain_id}
                  >
                    <option value="">Select a domain</option>
                    {translatedDomains.length > 0 ? (
                      translatedDomains.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.title} {d.hotel_id ? '- ' + d.hotel?.name : ''}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>No domains available</option>
                    )}
                  </select>
                </div>
                <div className="form-text">
                  <label>{t('form.title')} *</label>
                  <MultilingualInput value={titleTranslations} onChange={setTitleTranslations} defaultLang="fr" otherLang="en" />
                </div>
                <div className="form-text topMargArea">
                  <label>{t('form.description')}</label>
                  <MultilingualInput value={descriptionTranslations} onChange={setDescriptionTranslations} defaultLang="fr" otherLang="en" type="textarea" textareaClass="formTextArea" />
                </div>
                    <div className="capability-input topMargArea">
                    {(!formData.hotel_id && !selectedDomainObj?.hotel_id) && (
                      <Stack
                        direction="row"
                        spacing={1}
                        alignItems="center"
                        justifyContent="space-between"
                      >
                        <Typography>{t('form.hidden')}</Typography>
                        <Stack direction="row" spacing={1} alignItems="center">
                          <Typography>No</Typography>
                          <Switch
                            checked={formData.is_hidden ? true : false}
                            value={formData.is_hidden ? true : false}
                            onChange={handleHiddenFormSwitchChange}
                            inputProps={{ "aria-label": "status" }}
                          />
                          <Typography>Yes</Typography>
                        </Stack>
                      </Stack>
                    )}
                </div>
              </>
            )}

            {/* ---------- SUBCATEGORY CREATION (requires domain + parent) ---------- */}
            {formData.type === "subcategory" && (
              <>
                <div className="form-text">
                  <label>{t('form.domain')} *</label>
                  <select
                    required
                    name="domain_id"
                    onChange={handleChange}
                    value={formData.domain_id}
                  >
                    <option value="">Select a domain</option>
                    {translatedDomains.length > 0 ? (
                      translatedDomains.map((d) => (
                        <option key={d.id} value={d.id}>
                          {d.title} {d.hotel_id ? '- ' + d.hotel?.name : ''}
                        </option>
                      ))
                    ) : (
                      <option value="" disabled>No domains available</option>
                    )}
                  </select>
                </div>

                <div className="form-text">
                  <label>{t('form.category')} *</label>
                  <select
                    required
                    name="parent_id"
                    onChange={handleChange}
                    value={formData.parent_id}
                    disabled={!formData.domain_id}
                  >
                    <option value="">Select a category</option>
                    {translatedCategories.length > 0 ? (
                      translatedCategories.map((c) => (
                        <option key={c.id} value={c.id}>{c.title}</option>
                      ))
                    ) : (
                      <option value="" disabled>No categories available</option>
                    )}
                  </select>
                </div>
                <div className="form-text">
                  <label>{t('form.title')} *</label>
                  <MultilingualInput value={titleTranslations} onChange={setTitleTranslations} defaultLang="fr" otherLang="en" />
                </div>
                <div className="form-text topMargArea">
                  <label>{t('form.description')}</label>
                  <MultilingualInput value={descriptionTranslations} onChange={setDescriptionTranslations} defaultLang="fr" otherLang="en" type="textarea" textareaClass="formTextArea" />
                </div>
              </>
            )}

            {/* ---------- PRODUCT or SUBPRODUCT CREATION ---------- */}
            {(formData.type === "product" || formData.type === "subproduct") && (
              <>
                <div className="form-text">
                  <label>{t('form.domain')} *</label>
                  <select
                    required
                    name="domain_id"
                    onChange={(e) => {
                      const selectedId = e.target.value;
                      const selectedDomain = domain.find(d => d.id.toString() === selectedId);
                      setHotelProd(selectedDomain.hotel_id);
                      handleChange(e);
                    }}
                    value={formData.domain_id}
                  >
                    <option value="">Select a domain</option>
                    {translatedDomains.length > 0 ? (
                      translatedDomains.map((row) => (
                        <option key={row.id} value={row.id}>{row.title} {row.hotel_id ? '- ' + row.hotel?.name ?? '' : ''}</option>
                      ))
                    ) : (
                      <option value="" disabled>No domains available</option>
                    )}
                  </select>
                </div>
                <div className="form-text">
                  <label>{t('form.category')} *</label>
                  <select
                    required
                    name="parent_category_id"
                    onChange={handleChange}
                    value={formData.parent_category_id}
                  >
                    <option value="">Select a category</option>
                    {translatedCategories.length > 0 ? (
                      translatedCategories.map((row) => (
                        <option key={row.id} value={row.id}>{row.title}</option>
                      ))
                    ) : (
                      <option value="" disabled>No categories available</option>
                    )}
                  </select>
                </div>

                <div className="form-text">
                  <label>{t('form.subcategory')}</label>
                  <select
                    name="category_id"
                    onChange={handleChange}
                    value={formData.category_id}
                  >
                    <option value="">Select a Subcategory</option>
                    {translatedSubCategories.length > 0 ? (
                      translatedSubCategories.map((row) => (
                        <option key={row.id} value={row.id}>{row.title}</option>
                      ))
                    ) : (
                      <option value="" disabled>No Subcategories available</option>
                    )}
                  </select>
                </div>

                <div className="form-text">
                  <label>{t('form.name')} *</label>
                  <MultilingualInput value={nameTranslations} onChange={setNameTranslations} defaultLang="fr" otherLang="en" />
                </div>

                <div className="capability-input topMargArea">
                  {(!formData.hotel_id && !formData.hotel && !selectedDomainObj?.hotel_id && !selectedDomainObj?.hotel && !hotelProd) && (
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Typography>{t('form.hidden')}</Typography>
                      <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>No</Typography>
                        <Switch
                          checked={formData.is_hidden ? true : false}
                          value={formData.is_hidden ? true : false}
                          onChange={handleHiddenFormSwitchChange}
                          inputProps={{ "aria-label": "status" }}
                        />
                        <Typography>Yes</Typography>
                      </Stack>
                    </Stack>
                  )}
                </div>

                <div className="form-text topMargArea">
                  <label>{t('form.description')}</label>
                  <MultilingualInput value={descriptionTranslations} onChange={setDescriptionTranslations} defaultLang="fr" otherLang="en" type="textarea" textareaClass="formTextArea" />
                </div>

                <div className="form-text">
                  <label>{t('form.duration')} *</label>
                  <input
                    required
                    type="number"
                    id="duration"
                    name="duration"
                    value={formData.duration}
                    onChange={handleChange}
                    min="0"
                    max="240"
                    // step="1"
                    onWheel={(e) => e.target.blur()}
                    placeholder={t('form.durationPlaceholder')}
                  />
                </div>

                <div className="form-text">
                  <label>{t('form.price')} *</label>
                  <input
                    required
                    type="number"
                    name="price"
                    min="0"
                    max="9999"
                    value={formData.price}
                    onChange={handleChange}
                    // step="0.01"
                    onWheel={(e) => e.target.blur()}
                    placeholder={t('form.pricePlaceholder')}
                  />
                </div>
              </>
            )}

            <label className="fileLabel topMargArea" htmlFor="file">
              {t('form.image')}
            </label>
            <div className="fileField">
              <label htmlFor="file">
                <img className="imgFile" src={imageFile || ""} alt="File upload" />
                {fileName ? (
                  <div>Uploaded File: {fileName}</div>
                ) : (
                  <>
                    <div className="selectFileTo">{t('form.selectFile')}</div>
                    <div className="orDragAnd">{t('form.dragAndDrop')}</div>
                  </>
                )}
              </label>
              <input
                type="file"
                id="file"
                name="file"
                accept="image/*"
                onChange={handleChange}
                ref={fileInputRef}
                style={{ display: "none" }}
              />
            </div>

            <div className="capability-input">
              <Stack
                direction="row"
                spacing={1}
                alignItems="center"
                justifyContent="space-between"
              >
                <Typography>{t('form.active')}</Typography>
                <Stack direction="row" spacing={1} alignItems="center">
                  <Typography>{t('status.disabled')}</Typography>
                  <Switch
                    checked={formData.is_active ? true : false}
                    value={formData.is_active ? true : false}
                    onChange={handleFormSwitchChange}
                    inputProps={{ "aria-label": "status" }}
                  />
                  <Typography>{t('status.active')}</Typography>
                </Stack>
              </Stack>
            </div>

            <div className="actions">
              <button type="button" onClick={closeModal} className="btn-submit">
                {t('actions.cancel')}
              </button>
              <button type="submit" className="btn-submit">
                {t('actions.save')}
              </button>
            </div>
          </form>
        </div>
      </Modal>

      <Modal
        isOpen={zoneModalIsOpen}
        onRequestClose={closeZoneModal}
        style={customStyles}
        ariaHideApp={false}
        contentLabel="Manage Zones"
      >
        <div className="bloc-manage">
          <div className="manage-zones-modal">
            <h2>Manage Zones for {selectedDomain?.title}</h2>

            {/* Assigned Zones Section */}
            <div className="currently-managed">
              <h3>Assigned Zones</h3>
              <div className="tableau-list no-scroll">
                <div className="container">
                  <table>
                    <thead className="no-background">
                      <tr>
                        <th>ID</th>
                        <th>Domain Title</th>
                        <th>Zone Name</th>
                        <th></th>
                      </tr>
                    </thead>
                    <tbody>
                      {assignedZones.map((zone) => (
                        <tr key={zone.id}>
                          <td>{zone.id}</td>
                          <td>{selectedDomain?.title}</td>
                          <td>{zone.name}</td>
                          <td>
                            <button
                              className="form-submit"
                              onClick={() => handleUnassignZone(zone)}
                            >
                              Remove
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>

                </div>
              </div>
            </div>

            {/* Available Zones Section */}
            <div className="available-zones">
              <h3>Available Zones</h3>
              <div className="bloc-search no-background">
                <div className="container search-center">
                  <div className="search">
                    <div className="text-search">
                      <input
                        type="text"
                        name="search"
                        placeholder={t('form.searchPlaceholder')}
                        value={searchQuery}
                        onChange={(e) => {
                          const term = e.target.value.toLowerCase();
                          setSearchQuery(e.target.value);
                          if (!term) {
                            setAvailableZones(allZones);
                          } else {
                            const filtered = allZones.filter((zone) =>
                              zone.name.toLowerCase().includes(term)
                            );
                            setAvailableZones(filtered);
                          }
                        }}
                        className="form-text"
                      />
                      <input
                        type="submit"
                        onClick={handleSearch}
                        className="form-submit"
                        value={t('actions.search')}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="tableau-list no-scroll">
                <div className="container">
                  <table>
                    {availableZones.map((zone, index) => (
                      <thead key={index} className="no-background">
                        <tr>
                          <th>{zone.id}</th>
                          <th>{zone.name}</th>
                          <th>
                            <button
                              className="form-submit"
                              onClick={() => handleAssignZone(zone)}
                            >
                              Add
                            </button>
                          </th>
                        </tr>
                      </thead>
                    ))}
                  </table>
                </div>
              </div>
            </div>

            {/* Save Changes Button */}
            <button className="save-submit" onClick={handleSaveZones}>
              {t('actions.saveChanges')}
            </button>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default Product;
